import React from 'react';
import { FadeIn, Section, Button } from './ui';
import { Crown, Check, X, Shield, Users } from 'lucide-react';
export function EliteOfferSection() {
  return <Section variant="dark" className="!max-w-none !pt-1 md:!pt-2 !pb-6 md:!pb-16" data-id="element-55">
      <div className="max-w-[680px] mx-auto w-full" data-id="element-56">
        <FadeIn data-id="element-57">
          {/* Elite Offer Card — high visual impact */}
          <div className="relative" data-id="element-58">
            {/* Glow effect behind card */}
            <div className="absolute -inset-1 bg-gradient-to-b from-brand-gold/20 via-brand-gold/5 to-transparent rounded-3xl blur-xl" data-id="element-59" />

            <div className="relative bg-[#0a0a0a] border-2 border-brand-gold rounded-xl md:rounded-2xl p-3.5 md:p-8 overflow-hidden" data-id="element-60">
              {/* Animated corner accent */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-brand-gold/15 to-transparent" data-id="element-61" />

              {/* Recommended badge — CSS animation instead of framer-motion */}
              <div className="flex justify-center mb-2.5 md:mb-4" data-id="element-62">
                <div className="animate-badge-pulse bg-gradient-to-r from-brand-gold to-yellow-300 text-black font-black px-3.5 md:px-5 py-1.5 md:py-2 rounded-full text-[10px] md:text-sm flex items-center gap-1.5 md:gap-2 shadow-[0_0_20px_rgba(245,158,11,0.3)]" data-id="element-63">
                  <Crown size={14} data-id="element-64" />
                  <span data-id="element-65">⭐ RECOMENDADO — ELITE BUNDLE</span>
                </div>
              </div>

              <div className="text-center mb-2.5 md:mb-4" data-id="element-66">
                <h3 className="text-lg md:text-2xl font-black text-white mb-0.5 md:mb-1" data-id="element-67">
                  Todo el Sistema Base
                  <span className="text-brand-gold" data-id="element-68">
                    {' '}
                    + 2 Módulos Exclusivos
                  </span>
                </h3>
                <p className="text-gray-400 text-[11px] md:text-sm" data-id="element-69">
                  Resolvé el aula{' '}
                  <span className="text-white font-semibold" data-id="element-70">
                    Y lo que pasa fuera:
                  </span>{' '}
                  padres, reuniones e institución.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-5" data-id="element-71">
                <div className="bg-brand-gold/5 border border-brand-gold/20 rounded-lg md:rounded-xl p-2.5 md:p-3.5 flex items-start gap-2 md:gap-3" data-id="element-72">
                  <Shield size={16} className="text-brand-gold shrink-0 mt-0.5" data-id="element-73" />
                  <div data-id="element-74">
                    <p className="text-white font-bold text-[11px] md:text-sm mb-0 md:mb-0.5" data-id="element-75">
                      Diplomacia de Hierro
                    </p>
                    <p className="text-gray-400 text-[9px] md:text-[11px] leading-snug" data-id="element-76">
                      13 emails + Framework CALMA para padres difíciles
                    </p>
                  </div>
                </div>
                <div className="bg-brand-gold/5 border border-brand-gold/20 rounded-lg md:rounded-xl p-2.5 md:p-3.5 flex items-start gap-2 md:gap-3" data-id="element-77">
                  <Users size={16} className="text-brand-gold shrink-0 mt-0.5" data-id="element-78" />
                  <div data-id="element-79">
                    <p className="text-white font-bold text-[11px] md:text-sm mb-0 md:mb-0.5" data-id="element-80">
                      Marca Personal Docente
                    </p>
                    <p className="text-gray-400 text-[9px] md:text-[11px] leading-snug" data-id="element-81">
                      Posicionarte como irremplazable + Plan de 90 Días
                    </p>
                  </div>
                </div>
              </div>

              {/* Price block with strong contrast */}
              <div className="bg-brand-gold/10 border border-brand-gold/20 rounded-lg md:rounded-xl p-2.5 md:p-4 text-center mb-3 md:mb-5" data-id="element-82">
                <div className="flex items-center justify-center gap-2 md:gap-3 mb-0.5 md:mb-1" data-id="element-83">
                  <span className="text-gray-500 text-xs md:text-sm line-through" data-id="element-84">
                    $85.890
                  </span>
                  <span className="text-3xl md:text-5xl font-black text-brand-gold drop-shadow-[0_0_15px_rgba(245,158,11,0.3)]" data-id="element-85">
                    $29.990
                  </span>
                </div>
                <p className="text-green-400 font-bold text-[10px] md:text-sm" data-id="element-86">
                  Solo $10.000 más que el Base → $25.980 en valor extra
                </p>
              </div>

              <Button variant="gold" className="text-sm md:text-lg !min-h-[40px] md:!min-h-[52px] !py-2 md:!py-4 !shadow-[0_0_25px_rgba(245,158,11,0.25)]" data-id="element-87">
                <span data-id="element-88">QUIERO EL ELITE BUNDLE COMPLETO 👑</span>
                <span className="text-[9px] md:text-xs font-normal text-black/60" data-id="element-89">
                  🔒 Pago seguro · Acceso inmediato · Garantía 7 días
                </span>
              </Button>

              {/* Mini comparison */}
              <div className="mt-3 md:mt-5 pt-3 md:pt-4 border-t border-gray-800/50" data-id="element-90">
                <div className="grid grid-cols-3 gap-1 text-[9px] md:text-xs text-center" data-id="element-91">
                  <div data-id="element-92"></div>
                  <div className="text-gray-500 font-medium" data-id="element-93">Base</div>
                  <div className="text-brand-gold font-bold" data-id="element-94">Elite ⭐</div>
                </div>
                {[{
                label: '6 Tomos + 3 Bonus',
                base: true,
                elite: true
              }, {
                label: 'Diplomacia de Hierro',
                base: false,
                elite: true
              }, {
                label: 'Marca Personal',
                base: false,
                elite: true
              }].map((row, i) => <div key={i} className="grid grid-cols-3 gap-1 text-[9px] md:text-xs text-center py-1 md:py-1.5 border-t border-gray-800/30" data-id="element-95">
                    <div className="text-gray-500 text-left" data-id="element-96">{row.label}</div>
                    <div data-id="element-97">
                      {row.base ? <Check className="inline text-green-500" size={12} data-id="element-98" /> : <X className="inline text-red-500/40" size={12} data-id="element-99" />}
                    </div>
                    <div data-id="element-100">
                      <Check className="inline text-green-500" size={12} data-id="element-101" />
                      {!row.base && <span className="text-[8px] ml-0.5" data-id="element-102">💎</span>}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}